import { formatDate } from "utils/date";
import { BadgeLink, BadgeSubtitle, BadgeTitle } from "atoms";
import { Thumbnail } from "features/images";
import defaultProjectSrc from "assets/images/default-project-img.svg";
import { useOpenCall } from "../api/useOpenCall";

function OpenCallBadgeItem({
  openCallId,
  date,
}: {
  openCallId: string;
  date: string | undefined;
}) {
  const { data: oc } = useOpenCall(openCallId);

  if (!oc) {
    return null;
  }

  const badgeImage =
    oc.badgeImage ?? oc.heroImage ?? oc.partnerLogo ?? defaultProjectSrc;

  return (
    <li>
      <BadgeLink key={oc.id} to={`/open-calls/${oc.id}`}>
        <Thumbnail src={badgeImage} sizes="300px" aria-hidden />
        <BadgeTitle>{oc.title}</BadgeTitle>
        {typeof date === "string" && (
          <BadgeSubtitle>
            {formatDate(date, {
              month: "long",
              year: "numeric",
            })}
          </BadgeSubtitle>
        )}
      </BadgeLink>
    </li>
  );
}

export { OpenCallBadgeItem };
